import { render, staticRenderFns } from "./userunion.vue?vue&type=template&id=55b38093"
import script from "./userunion.vue?vue&type=script&lang=js"
export * from "./userunion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports